import ApiHandler from './ApiHandler';

export default {
    addExperience: data => ApiHandler.post('/experience-stats', data),
    deleteExperience: id => ApiHandler.delete(`/experience-stats/${id}`),
    updateExperience: ({ id, data }) =>
        ApiHandler.put(`/experience-stats/${id}`, data)
};
